import {
  createBaseThemeOptions,
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';

export const OxqTheme = createUnifiedTheme({
  ...createBaseThemeOptions({
    palette: {
      ...palettes.light,
      primary: {
        main: 'rgb(255, 34, 76)', // --color-oxq-red
      },
      secondary: {
        main: 'rgb(51, 51, 51)', // --color-oxq-black-400
      },
      error: {
        main: 'rgb(255, 34, 76)', // same as red for brand consistency
      },
      warning: {
        main: 'rgb(255, 170, 0)', // Custom amber for warning (not in root, pick something readable)
      },
      info: {
        main: 'rgb(102, 102, 102)', // --color-oxq-black-300
      },
      success: {
        main: 'rgb(0, 153, 0)', // Custom green (choose readable value)
      },
      background: {
        default: 'rgb(255, 255, 255)', // --color-oxq-body-white
        paper: 'rgb(230, 230, 230)', // --color-oxq-black-50
      },
      banner: {
        info: 'rgb(102, 102, 102)', // --color-oxq-black-300
        error: 'rgb(255, 34, 76)', // --color-oxq-red
        text: 'rgb(0, 0, 0)', // --color-oxq-black
        link: 'rgb(13, 13, 13)', // --color-oxq-black-500
      },
      errorBackground: 'rgb(255, 34, 76)',
      warningBackground: 'rgb(255, 170, 0)',
      infoBackground: 'rgb(102, 102, 102)',
      navigation: {
        background: 'rgb(13, 13, 13)', // --color-oxq-black-500
        indicator: 'rgb(255, 34, 76)', // --color-oxq-red
        color: 'rgb(255, 255, 255)', // --color-oxq-white
        selectedColor: 'rgb(255, 34, 76)', // strong contrast
      },
    },
  }),
  pageTheme: {
    home: genPageTheme({ colors: ['#ff224c', '#0d0d0d'], shape: shapes.wave }),
    documentation: genPageTheme({
      colors: ['#ff224c', '#0d0d0d'],
      shape: shapes.wave2,
    }),
    tool: genPageTheme({ colors: ['#ff224c', '#0d0d0d'], shape: shapes.round }),
    service: genPageTheme({
      colors: ['#ff224c', '#0d0d0d'],
      shape: shapes.wave,
    }),
    website: genPageTheme({
      colors: ['#ff224c', '#0d0d0d'],
      shape: shapes.wave,
    }),
    library: genPageTheme({
      colors: ['#ff224c', '#0d0d0d'],
      shape: shapes.wave,
    }),
    other: genPageTheme({ colors: ['#ff224c', '#0d0d0d'], shape: shapes.wave }),
    app: genPageTheme({ colors: ['#ff224c', '#0d0d0d'], shape: shapes.wave }),
    apis: genPageTheme({ colors: ['#ff224c', '#0d0d0d'], shape: shapes.wave }),
  },
});
